import styled from 'styled-components';
import arrowRight from '~/assets/icons/arrow_right.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledScroll = styled.div`
	display: flex;
	gap: 10px;
	overflow-x: auto;
	overflow-y: hidden;
	touch-action: pan-x;
	overscroll-behavior: contain;
	scroll-behavior: smooth;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	@property --leftFlat {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}
	@property --leftRamp {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}
	@property --rightFlat {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}
	@property --rightRamp {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	-webkit-mask-image: linear-gradient(
		to right,
		transparent 0,
		transparent var(--leftFlat),
		black var(--leftRamp),
		black calc(100% - var(--rightRamp)),
		transparent calc(100% - var(--rightFlat)),
		transparent 100%
	);
	mask-image: linear-gradient(
		to right,
		transparent 0,
		transparent var(--leftFlat),
		black var(--leftRamp),
		black calc(100% - var(--rightRamp)),
		transparent calc(100% - var(--rightFlat)),
		transparent 100%
	);
	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;
	-webkit-mask-size: 100% 100%;
	mask-size: 100% 100%;

	transition:
		--leftFlat 300ms ease,
		--leftRamp 300ms ease,
		--rightFlat 300ms ease,
		--rightRamp 300ms ease;
`;

const StyledBadge = styled.div<{ $color: string | null }>`
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	width: 72px;
	height: 40px;
	border-radius: 5px;
	background-color: ${(props) =>
		props.$color ? `${props.$color}40` : 'rgba(255, 255, 255, 0.02)'};
	border: 1px solid
		${(props) =>
			props.$color ? `${props.$color}80` : 'rgba(255, 255, 255, 0.05)'};
`;

const StyledBadgeIcon = styled.img<{ $active: boolean }>`
	width: 20px;
	height: 20px;
	object-fit: contain;
	opacity: ${(props) => (props.$active ? 1 : 0.25)};
	user-select: none;
	pointer-events: none;
`;

const StyledBadgeDivider = styled.div`
	width: 1px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledBadgeLevel = styled.div<{ $active: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
		opacity: ${(props) => (props.$active ? 1 : 0.25)};
	}
`;

const StyledNavButton = styled.button<{
	$side: 'left' | 'right';
	$visible: boolean;
}>`
	position: absolute;
	top: 0;
	${(props) => props.$side}: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	padding: 0;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	cursor: pointer;
	opacity: ${(props) => (props.$visible ? 1 : 0)};
	pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
	transition:
		background-color 0.3s ease,
		opacity 0.3s ease;

	div {
		width: 7px;
		height: 14px;
		mask-image: url(${arrowRight});
		mask-size: contain;
		mask-repeat: no-repeat;
		mask-position: center;
		-webkit-mask-image: url(${arrowRight});
		-webkit-mask-size: contain;
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-position: center;
		background-color: #ffffff;
		transform: ${(props) =>
			props.$side === 'left' ? 'rotate(180deg)' : 'none'};
	}

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;

export {
	StyledBadge,
	StyledBadgeDivider,
	StyledBadgeIcon,
	StyledBadgeLevel,
	StyledContainer,
	StyledNavButton,
	StyledScroll,
};
